module.exports = __webpack_public_path__ + "img/helpExaminations.2be6539b.svg";